/**
 * Tiny ISO-2 helper for the ransomware geo drilldown.
 *
 * - `countryFlag` derives a flag emoji from a 2-letter code via the
 *   regional-indicator codepoint trick. Returns "" for invalid input.
 * - `countryName` provides display names for the ~50 most-hit countries
 *   on ransomware.live; long tail falls back to the ISO-2 code itself
 *   so we don't pull in a 200-country dependency.
 */

export function countryFlag(iso2: string | null | undefined): string {
  if (!iso2) return ''
  const s = iso2.toUpperCase()
  if (s.length !== 2 || !/^[A-Z]{2}$/.test(s)) return ''
  return String.fromCodePoint(...s.split('').map(c => 127397 + c.charCodeAt(0)))
}

const NAMES: Record<string, string> = {
  US: 'United States', GB: 'United Kingdom', DE: 'Germany', FR: 'France',
  IT: 'Italy', ES: 'Spain', NL: 'Netherlands', BE: 'Belgium',
  CA: 'Canada', AU: 'Australia', BR: 'Brazil', MX: 'Mexico',
  JP: 'Japan', CN: 'China', IN: 'India', KR: 'South Korea',
  RU: 'Russia', PL: 'Poland', SE: 'Sweden', NO: 'Norway',
  FI: 'Finland', CH: 'Switzerland', AT: 'Austria', IE: 'Ireland',
  AR: 'Argentina', CL: 'Chile', ZA: 'South Africa', AE: 'UAE',
  SG: 'Singapore', TW: 'Taiwan', TH: 'Thailand', ID: 'Indonesia',
  PT: 'Portugal', GR: 'Greece', DK: 'Denmark', NZ: 'New Zealand',
  TR: 'Turkey', IL: 'Israel', PH: 'Philippines', MY: 'Malaysia',
  VN: 'Vietnam', CZ: 'Czechia', HU: 'Hungary', RO: 'Romania',
  CO: 'Colombia', PE: 'Peru', SA: 'Saudi Arabia', EG: 'Egypt',
  NG: 'Nigeria', KE: 'Kenya', PK: 'Pakistan', BD: 'Bangladesh',
}

export function countryName(iso2: string | null | undefined): string {
  if (!iso2) return ''
  const s = iso2.toUpperCase()
  return NAMES[s] || s
}
